import React from 'react';
import PropTypes from 'prop-types';
import colors from '../../../styles/export.module.scss.js';
import '../../../components/Button/Button.js';
import '../../../components/AppLogo/AppLogo.js';
import '../../../components/Avatar/Avatar.js';
import '../../../components/Input/Input.js';
import '../../../components/Input/PasswordInput.js';
import Icon from '../../../components/Icon/Icon.js';
import '../../../components/Image/Image.js';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner.js';
import '../../../components/Note/Note.js';
import '../../../components/RadioButton/RadioButton.js';
import '../../../components/RoundButton/RoundButton.js';
import '../../../components/RoundButton/RoundButtonElement/RoundButtonElement.js';
import '../../../components/Expandable/Expandable.js';
import '../../../components/PopOver/PopOver.js';
import '../../../components/Wizard/Wizard.js';
import '../../../components/Wizard/WizardStepContent/WizardStepContent.js';
import '../../../components/Wizard/NavigationBar/NavigationBar.js';
import '../../../components/ToggleButton/ToggleButton.js';
import '../../../components/ToggleButton/ToggleButtonElement/ToggleButtonElement.js';
import '../../../components/Wizard/ProgressBar/ProgressBar.js';
import '../../../components/Checkbox/Checkbox.js';
import '../../../components/SelectionField/SelectionField.js';
import '../../../components/Card/Card.js';
import '../../../components/Badge/Badge.js';
import '../../../components/SettingsItem/SettingsItem.js';
import '../../../components/SortableList/SortableList.js';
import '../../../components/Contacts/ContactItem.js';
import '../../../components/TopElement/TopElement.js';
import '../../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import 'classnames';
import 'react-i18next';
import '../../../services/apiEndpoint/apiEndpoint.js';
import '../../../services/translation/translationUtils.module.scss.js';
import '../../../i18n/i18n.js';
import '../../../components/Flag/Flag.js';
import '../../../services/appConstants/appConstants.js';
import '../../../node_modules/tslib/tslib.es6.js';
import 'react-ga4';
import '../../../services/utilities/countries.js';
import '@sentry/react';
import '@apollo/client';
import '@apollo/client/link/batch-http';
import '@apollo/client/link/error';
import 'uuid';
import '../../../services/graphql/default-client/DefaultClient.js';
import 'axios';
import 'date-fns/isAfter';
import 'date-fns/addMinutes';
import '../../../services/logout/rest-default-client/restDefaultClient.js';
import '../../../services/poller/PollManager.js';
import 'react-dom';
import 'react-redux';
import '../../../services/ipcWeb/IpcContext.js';
import 'js-cookie';
import '../../../services/utilities/languageUtil.js';
import '../../../services/useContactUs/ContactUs.gql.js';
import '../../../services/storageHandler/StorageHandler.js';
import '../../../services/abortablePromise/AbortablePromise.js';
import '../../../services/abortablePoller/AbortablePoller.js';
import '../../../services/abortablePoller/ResumablePoller.js';
import '../../../services/ipcWeb/ipcService.js';
import '../../../components/DropDownBox/DropDownBox.module.scss.js';
import '../../../components/PhoneSelectButton/PhoneSelectButton.module.scss.js';
import '../../../components/InternationalPhonePicker/InternationalPhonePicker.module.scss.js';
import '../../../components/Carousel/ImageCarousel.module.scss.js';
import styles from './InstallationErrorStatus.module.scss.js';

/* eslint-disable react/prop-types */
var InstallationErrorStatus = function InstallationErrorStatus(_ref) {
  var t = _ref.t,
    fatalErrors = _ref.fatalErrors,
    nodeLoginWarning = _ref.nodeLoginWarning;
  return fatalErrors && fatalErrors.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.rssiItem
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.icon
  }, /*#__PURE__*/React.createElement(Icon, {
    dataTestId: "signal-none-timeout",
    icon: "icon-failed",
    size: "xlarge",
    color: colors.red
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rssiTitle
  }, t('MPLIB_DEVICE_FATAL_FAULT')), fatalErrors.map(function (error) {
    return /*#__PURE__*/React.createElement("li", {
      key: error,
      id: "device-error-".concat(error),
      className: styles.rssiTitle
    }, t("MPLIB_".concat(error)));
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rssiTitle
  }, t('MPLIB_CALL_SUPPORT')))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.rssiItem
  }, /*#__PURE__*/React.createElement(LoadingSpinner, {
    dataTestId: "polling-spinner-rssi",
    relative: true,
    isLoading: true,
    centered: true,
    size: "medium",
    className: styles.spinner
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rssiTitle
  }, t('MPLIB_CHECKING_FOR_ERRORS')), /*#__PURE__*/React.createElement("div", {
    className: styles.text
  }, t('MPLIB_POLLING_RSSI')), nodeLoginWarning && /*#__PURE__*/React.createElement("div", {
    className: styles.error
  }, nodeLoginWarning)));
};
InstallationErrorStatus.propTypes = {
  t: PropTypes.func.isRequired,
  nodeLoginWarning: PropTypes.string,
  fatalErrors: PropTypes.arrayOf(PropTypes.string)
};
InstallationErrorStatus.defaultProps = {
  nodeLoginWarning: '',
  fatalErrors: []
};

export { InstallationErrorStatus };
